import { useLayoutEffect, useState } from 'react';
// Measure rem independently of page zoom. No browser/system preferences are changed.
export default function useEditorTextScale(probe) {
  const [scale, setScale] = useState(1);
  useLayoutEffect(() => {
    const node = probe.current;
    if (!node) return;
    const measure = () => setScale((parseFloat(getComputedStyle(node).width) || 16) / 16);
    measure();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    observer?.observe(node);
    window.addEventListener('resize', measure);
    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, [probe]);
  return scale;
}
